/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";

const Hero = ({ setShowModal }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="bg-white">
      {/* Navbar */}
      <header className="relative flex items-center justify-between px-6 md:px-12">
        {/* Logo */}
        <div className="flex items-center space-x-2">
          <img
            src="https://cdn.prod.website-files.com/63fdf8c863bcf0c02efdffbc/64144c23e693f7d7f5cdb958_chorus_logo.svg"
            alt="Chorus One"
            className="w-[140px] h-[90px]"
          />
        </div>

        {/* Desktop Menu */}
        <nav className="hidden space-x-6 font-medium text-gray-800 md:flex">
          <a href="#">Products</a>
          <a href="#">Networks</a>
          <a href="#">Research</a>
          <a href="#">Ventures</a>
          <a href="#">Resources</a>
          <a href="#">About</a>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="p-2 border border-black rounded-full md:hidden"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? (
            // Close Icon
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6 text-gray-800"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          ) : (
            // Hamburger Icon
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6 text-gray-800"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          )}
        </button>

        {/* Mobile Menu (dropdown) */}
        {isOpen && (
          <div className="absolute left-0 w-full bg-white border-t shadow-md top-full md:hidden">
            <nav className="flex flex-col px-6 py-4 space-y-4 font-medium text-gray-800">
              <a href="#">Products</a>
              <a href="#">Networks</a>
              <a href="#">Research</a>
              <a href="#">Ventures</a>
              <a href="#">Resources</a>
              <a href="#">About</a>
            </nav>
          </div>
        )}
      </header>

      {/* Hero Section */}
      <section className="flex flex-col items-center justify-between px-6 py-16 md:flex-row md:px-12">
        {/* Left Text */}
        <div className="max-w-xl text-center md:text-left">
          <h1 className="text-[56px] font-medium leading-[62px] text-center text-transparent bg-clip-text bg-gradient-to-r from-[#102E31] to-[#157D87] md:text-[88px] md:text-left md:leading-[100px]">
            Stake without <br /> complexities
          </h1>
          <p className="mt-6 text-xl md:text-[24px] font-normal leading-8 text-center text-[#272727] md:text-left">
            Chorus One provides quick staking integrations for institutions and
            forward thinking investors, industry-leading research, and support
            for 40+ protocols.
          </p>

          {/* Buttons */}
          <div className="flex flex-col items-center mt-8 space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4">
            <div
              onClick={() => {
                setShowModal(true);
              }}
            >
              <p
                href="#"
                className="flex items-center justify-center py-1 font-medium text-white transition bg-[#198E9C] rounded-full hover:bg-teal-800 pl-2 pr-4"
              >
                <span className="px-3 py-2 mr-2 text-xl text-black bg-white border border-black rounded-full">
                  →
                </span>
                Connect Wallet
              </p>
            </div>

            <div
              onClick={() => {
                setShowModal(true);
              }}
            >
              <p
                href="#"
                className="flex items-center justify-center py-1 font-medium text-white transition bg-[#198E9C] rounded-full hover:bg-teal-800 pl-2 pr-4"
              >
                <span className="px-3 py-2 mr-2 text-xl text-black bg-white border border-black rounded-full">
                  →
                </span>
                Get In Touch
              </p>
            </div>
          </div>

          {/* Small Link */}
          <a
            href="#"
            className="inline-block mt-6 text-sm text-gray-600 underline"
          >
            View All Networks
          </a>
        </div>

        {/* Right Image (Geometric Shape) */}
        <div className="justify-center hidden mt-12 md:flex md:mt-0 md:ml-12">
          <div className="relative w-64 h-64">
            {/* Big Diamond */}
            <div className="absolute inset-0 overflow-hidden rotate-45">
              <img
                src="https://picsum.photos/400/400?random=1"
                alt="Diamond"
                className="object-cover w-full h-full"
              />
            </div>
            {/* Small Diamonds */}
            <div className="absolute w-16 h-16 overflow-hidden rotate-45 -translate-x-1/2 -top-10 left-1/2">
              <img
                src="https://picsum.photos/200/200?random=2"
                alt=""
                className="object-cover w-full h-full"
              />
            </div>
            <div className="absolute w-16 h-16 overflow-hidden rotate-45 -translate-x-1/2 -bottom-10 left-1/2">
              <img
                src="https://picsum.photos/200/200?random=3"
                alt=""
                className="object-cover w-full h-full"
              />
            </div>
            <div className="absolute w-16 h-16 overflow-hidden rotate-45 -translate-y-1/2 top-1/2 -left-10">
              <img
                src="https://picsum.photos/200/200?random=4"
                alt=""
                className="object-cover w-full h-full"
              />
            </div>
            <div className="absolute w-16 h-16 overflow-hidden rotate-45 -translate-y-1/2 top-1/2 -right-10">
              <img
                src="https://picsum.photos/200/200?random=5"
                alt=""
                className="object-cover w-full h-full"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Hero;
